import React from "react";
import NosotrosItem from "../components/index/nosotrosItem";
import FaqItem from "../components/index/faqItem";
import "./index.css";

// se importan las imágenes
import img1 from "../resources/portada1.jpg"
import img1Avif from "../resources/portada1.avif"
import img2 from "../resources/portada3.png"
import img2Avif from "../resources/portada3.avif"
import img3 from "../resources/portada6.png"
import andres from "../resources/andres.jpeg"
import andresAvif from "../resources/andres.avif"
import daniel from "../resources/daniel.jpeg"
import danielAvif from "../resources/daniel.avif"
import Contacto from "../components/index/contacto.tsx";



/**
 * This is the main page of the application
 * 
 */
const IndexPage = () => {

  return (
    <>
      <section className="hero">
        <div className="hero-text">
          <h1>
            Tu mascota en las mejores manos
          </h1>
          <p>
            Donde el amor por las mascotas se encuentra con la innovación. Descubre una nueva forma de cuidar a tus compañeros peludos con PawZone.
          </p>
        </div>
        <div className="hero-img shadow">
          <picture>
            <source srcSet={img1Avif} type="image/avif"/>
            <img src={img1} alt="foto perrito"/>
          </picture>
        </div>
      </section>
      <section className="choose" >
        <h2>¿Por qué elegirnos?</h2>
        <div className="choose-img">
          <img src={img3} alt="foto perrito"/>
        </div>
        <div className="choose-text">
          <p>
          PawZone es más que una app; es un compañero en el viaje de cuidado de tu mascota, diseñado para simplificar tu vida mientras enriqueces la suya.
          </p>
          <h3>Salud y Bienestar en un Solo Lugar</h3>
          <p>
          Olvídate de los archivos perdidos o los detalles olvidados sobre la salud de tu mascota. Te ofrecemos un registro detallado de su historial médico, accesible en todo momento. Añadimos recordatorios personalizados para sus cuidados, facilitando su recuperación y bienestar diario sin complicaciones.
          </p>
          <h3>Foros de Comunidad</h3>
          <p>
          Conéctate con otros dueños de mascotas y profesionales de la industria para compartir consejos, experiencias y conocimientos. Nuestros foros de comunidad son el lugar perfecto para hacer preguntas, obtener respuestas y compartir tus propias ideas y experiencias.
          </p>
        </div>
      </section>
      <section className="services" style={{textAlign: "center", padding: 25}}>
        <div>
          <h2>
            Ficha clínica digital
          </h2>
          <p>
          En PawZone, revolucionamos el seguimiento de la salud de tu mascota con nuestra exclusiva ficha clínica digital. Esta herramienta es esencial para mantener organizado cada detalle sobre el bienestar de tu compañero, ofreciéndote:
          <br/>

          <span style={{fontWeight: "bold"}}>Historial Completo: </span>
          Desde vacunas hasta consultas, registra cada procedimiento médico y mantenlo accesible 24/7.
          <br/>
          <span style={{fontWeight: "bold"}}>Recordatorios Personalizados: </span>
          No más olvidos. Recibe avisos de vacunas, citas y medicamentos directamente en tu dispositivo.
          <br/>
          <span style={{fontWeight: "bold"}}>Acceso Fácil y Seguro: </span>
          Consulta la información de tu mascota cuando la necesites, y compártela fácilmente con profesionales.
          <br/>
          Con la ficha clínica digital de PawZone, garantizas un cuidado continuo y eficiente para tu mascota, simplificando su bienestar y tu tranquilidad.
          </p>
        </div>
        <picture>
          <source srcSet={img2Avif} type="image/avif"/>
          <img src={img2} alt="foto perrito"/>
        </picture>
      </section>
      <section style={{textAlign: "center", padding: 25, maxWidth: 1000, margin: "auto"}}>
        <h2>Nosotros</h2>
        <p>
        PawZone emergió de una chispa de innovación en el corazón de un equipo de estudiantes de ingeniería de la Universidad de Chile, unidos por su pasión por las mascotas y la tecnología. Al enfrentarse a los desafíos cotidianos del cuidado de sus propios animales, identificaron la necesidad de una solución integral que abordara la gestión de la salud y bienestar de las mascotas de una manera moderna y accesible. Inspirados por este desafío, transformaron su visión en realidad, dando vida a PawZone.
        </p>
        <p>
        Nuestra visión en PawZone es revolucionar el cuidado de las mascotas, centralizando en una sola plataforma todo lo relacionado con su salud y felicidad. Creemos firmemente en el potencial de mejorar la calidad de vida de nuestras mascotas a través de un acceso simplificado a registros médicos detallados, seguimientos de tratamientos y una comunidad de apoyo para compartir experiencias y consejos. Al hacerlo, queremos empoderar a los dueños para que tomen las mejores decisiones en cuanto al cuidado de sus compañeros peludos.
        </p>
        <div style={{display: "flex", justifyContent: "space-evenly", flexWrap: "wrap"}}>
          <NosotrosItem 
            imagen={andres}
            ligthImage={andresAvif}
            nombre="Andres Oñate"
            puesto="CEO y Fundador"
          />
          <NosotrosItem 
            imagen={daniel}
            ligthImage={danielAvif}
            nombre="Daniel Radrigán"
            puesto="CTO y Fundador"
          />
        </div>
      </section>
      <section style={{textAlign: "center", padding: 25, maxWidth: 1000, margin: "auto"}}>
        <h2>Preguntas frecuentes</h2>
        <FaqItem
          question="¿Cómo puedo registrar a mi mascota en PawZone?"
          answer="Para registrar a tu mascota en PawZone, simplemente debes crear una cuenta de usuario, ir a Mi mascota y luego agregar Mascota. Necesitarás proporcionar información básica como el nombre, edad, raza y cualquier detalle relevante sobre su salud."
        />
        <FaqItem 
          question="¿Qué beneficios tiene la ficha clínica digital de mi mascota?"
          answer="La ficha clínica digital permite un seguimiento detallado de la salud de tu mascota. Facilita el almacenamiento de su historial médico, vacunaciones, alergias, tratamientos y citas veterinarias. Esto es especialmente útil para tener un control preciso sobre su salud y para compartir información vital con profesionales veterinarios rápidamente."
        />
        <FaqItem 
          question="¿Cómo puedo utilizar el foro de PawZone?"
          answer="El foro de PawZone está disponible para todos los usuarios registrados. Es un espacio para compartir experiencias, consejos y dudas sobre el cuidado de las mascotas. Para mantener un ambiente positivo y útil, pedimos a todos los usuarios que sigan nuestras directrices de respeto y cordialidad."
        />
        <FaqItem 
          question="¿Puedo acceder a PawZone desde mi teléfono móvil?"
          answer="Sí, PawZone es totalmente accesible desde dispositivos móviles. Nuestra plataforma está diseñada para ser amigable y fácil de usar en cualquier dispositivo, asegurando que puedas acceder a la información y servicios de tus mascotas en cualquier momento y lugar."
        />
      </section>
      <Contacto />
    </>
  );
}

export default IndexPage;